import React, { useEffect } from "react";
import { useIntl } from "gatsby-plugin-react-intl";

import Logo from "../Logo";
import Burger from "./Burger";

import { AnnouncementBanner } from "../AnnouncementBanner";

import * as S from "./styled";

function changeSpanishBadgeVisibility({ visible }) {
  const weSpeakYourLanguageEs = document.querySelector(
    "#badge-hablamos-tu-idioma"
  );
  if (weSpeakYourLanguageEs) {
    weSpeakYourLanguageEs.style.display = Boolean(visible) ? "block" : "none";
  }
}

const NavBarTools = ({ navName }) => {
  const intl = useIntl();

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.onscroll = function () {
        if (
          document.body.scrollTop > 50 ||
          document.documentElement.scrollTop > 50
        ) {
          const header = document.querySelector("header");
          if (header) {
            header.style.boxShadow = "0px 9px 15px rgba(0,0,0,0.05)";
            header.style.transition = "all .2s";
          }
          if (intl.locale === "es") {
            changeSpanishBadgeVisibility({ visible: false });
          }
        } else {
          const header = document.querySelector("header");
          if (header) {
            header.style.boxShadow = "none";
          }
          if (intl.locale === "es") {
            changeSpanishBadgeVisibility({ visible: true });
          }
        }
      };
    }
  });

  return (
    <S.Nav>
      {(() => {
        switch (navName) {
          case "page-talents":
            return (
              <S.NavWrapper>
                <S.SkipeToContent href="#content">
                  {intl.formatMessage({ id: "buttons.skipToContent" })}
                </S.SkipeToContent>
                <S.Container>
                  <Logo />
                  <Burger />
                </S.Container>
              </S.NavWrapper>
            );

          case "page-form-no-scape-no-back":
            return (
              <S.NavWrapper>
                <S.SkipeToContent href="#content">
                  {intl.formatMessage({ id: "buttons.skipToContent" })}
                </S.SkipeToContent>
                <S.Container>
                  <Logo />
                  <Burger
                    color="#222"
                    burgerName="page-form-no-scape-no-back"
                  />
                </S.Container>
              </S.NavWrapper>
            );

          case "no-scape-partern-stack":
            return (
              <S.NavWrapper>
                <S.SkipeToContent href="#content">
                  {intl.formatMessage({ id: "buttons.skipToContent" })}
                </S.SkipeToContent>
                <S.Container>
                  <Logo />
                  <Burger color="#222" burgerName="no-scape-partern-stack" />
                </S.Container>
              </S.NavWrapper>
            );

          case "page-form-no-scape":
            return (
              <S.NavWrapper>
                <S.SkipeToContent href="#content">
                  {intl.formatMessage({ id: "buttons.skipToContent" })}
                </S.SkipeToContent>
                <S.Container>
                  <Logo />
                  <Burger color="#222" burgerName="page-form-no-scape" />
                </S.Container>
              </S.NavWrapper>
            );

          case "no-scape-one":
            return (
              <S.OneNavBar>
                <S.ContainerOne>
                  <Logo nameLogo="no-scape-one" />
                </S.ContainerOne>
              </S.OneNavBar>
            );

          case "thankyou-page":
            return (
              <S.NavWrapper>
                <S.SkipeToContent href="#content">
                  {intl.formatMessage({ id: "buttons.skipToContent" })}
                </S.SkipeToContent>
                <S.Container>
                  <Logo />
                  <Burger burgerName="thankyou-page" />
                </S.Container>
              </S.NavWrapper>
            );

          default:
            return (
              <>
                <AnnouncementBanner
                  // isActive
                  strong="Avalie nossa plataforma"
                  text=" • Comprove a eficácia da Axur com um caso real de ameaça contra sua empresa"
                  labelLink=" Teste agora"
                  link="/book-a-demo-1/"
                  hideOnPages={[
                    "/pt/",
                    "/es/",
                    "/obrigado-monitoramento-ameacas",
                    "/obrigado-monitoramento-ameacas-ativado",
                    "/gestao-ameacas-operacao-financeira",
                    "/gestao-ameacas-digitais-ecommerce",
                    "/gestao-ameacas-digitais-saas",
                    "/obrigado-axur-no-mindthesec",
                  ]}
                />
                <S.NavWrapper>
                  <S.SkipeToContent href="#content">
                    {intl.formatMessage({ id: "buttons.skipToContent" })}
                  </S.SkipeToContent>
                  <S.Container>
                    <Logo />
                    <Burger />
                  </S.Container>
                </S.NavWrapper>
              </>
            );
        }
      })()}
    </S.Nav>
  );
};

export default NavBarTools;
